import type { SelectedAsset } from '@/contexts/InvestContext';

export interface BrokerProps {
  id: number;
  uuid: string;
  active: boolean;
  broker_crypto: boolean;
  broker_exchange: boolean;
  broker_order: boolean;
  display_order: number;
  name: string;
  thumb_img: string;
  url_campaign: string;
}

export type InvestmentOrder = {
  type: keyof typeof INVESTMENT_ORDER_TYPES_TRANSLATE;
  asset: NonNullable<SelectedAsset>;
  amount: string;
};

export enum INVESTMENT_ORDER_TYPES_TRANSLATE {
  buy = 'Comprar',
  sell = 'Vender',
}

export interface BrokerListProps {
  id: number;
  uuid: string;
  active: boolean;
  broker_crypto: boolean;
  broker_exchange: boolean;
  broker_order: boolean;
  display_order: number;
  type: string;
  name: string;
  thumb_img: string;
  url_campaign: string;
}
